import { render, staticRenderFns } from "./pyVideo.vue?vue&type=template&id=36a54f08&scoped=true"
import script from "./pyVideo.vue?vue&type=script&lang=js"
export * from "./pyVideo.vue?vue&type=script&lang=js"
import style0 from "./pyVideo.vue?vue&type=style&index=0&id=36a54f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a54f08",
  null
  
)

export default component.exports